import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class ChannelRelationshipCreationError extends CodedError {
  static get errorName() {
    return errorCodes.channelRelationshipCreationError.code;
  }

  constructor(message: string = errorCodes.channelRelationshipCreationError.message) {
    super(message);
    this.code = errorCodes.channelRelationshipCreationError.code;
    this.message = `${message} ${errorCodes.channelRelationshipCreationError.code}`;
    this.name = errorCodes.channelRelationshipCreationError.name;
  }
}
